import debounce from "lodash-es/debounce"

const DEBOUNCE_TIME = 500

export default class Slideshow {
  constructor(selector) {
    this.slideshowElement = document.getElementById(selector)
    this.slides = this.slideshowElement.getElementsByClassName("slide")

    this.currentSlideIndex = 0
    this.autoplay = this.slideshowElement.getAttribute("data-autoplay")
    this.autoplaySpeed = this.slideshowElement.getAttribute("data-autoplay-speed")

    if (this.autoplay) this.autoPlay()

    window.addEventListener("load", this.resize.bind(this))
    window.addEventListener("resize", debounce(this.resize.bind(this), DEBOUNCE_TIME))
  }

  autoPlay() {
    setTimeout(() => this.next(), this.autoplaySpeed)
  }

  next() {
    this.currentSlideIndex += 1

    if (this.currentSlideIndex === this.slides.length) {
      this.currentSlideIndex = 0
    }

    for (let slide of this.slides) {
      slide.classList.add("hide")
    }

    this.slides[this.currentSlideIndex].classList.remove("hide")

    this.autoPlay()
  }

  resize() {
    const firstSlide = this.slides[0]
    const slideHeight = firstSlide.offsetHeight

    this.slideshowElement.style.height = `${slideHeight}px`
  }
}
